import React from 'react';
import { Button } from '@bynder/design-system';
import { IconFilterFunnel } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

const OverviewFilters = () => {
    const { translate } = useTranslate();

    return (
        <Button
            variant="clean"
            icon={<IconFilterFunnel />}
            aria-label={translate('components.overview.filters.button.label')}
        />
    );
};

export default OverviewFilters;
